(function ErezClientEmailLinkReservationForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientEmailLinkReservation',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.Typeahead(
			'.client-email-reservation-autocomplete',
			function search(term, display, $self)
			{
				var _request = Adzuki.Ajax.get('/Reservations/autocomplete/' + term + '/1');
				_request.then(function searchResults(response)
				{
					display(response);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for reservations."}]);
				});
			},
			function select(item) {
				if (item.id !== null) {
					$('.client-email-reservation-autocomplete').removeClass('ajax-spinner');
					$('#clientemaillinkreservation-reservation_id').val(item.id);
				}
			}
		);

		Adzuki.Typeahead(
			'.client-email-opportunity-autocomplete',
			function search(term, display, $self)
			{
				var _request = Adzuki.Ajax.get('/ClientOpportunities/typeaheadSearch/' + term);
				_request.then(function searchResults(response)
				{
					display(response);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for sales opportunities."}]);
				});
			},
			function select(item) {
				if (item.id !== null) {
					$('.client-email-opportunity-autocomplete').removeClass('ajax-spinner');
					$('#clientemaillinkreservation-opportunity_id').val(item.id);
				}
			}
		);

		Adzuki.Typeahead(
			'.client-email-group-autocomplete',
			function search(term, display, $self)
			{
				var _request = Adzuki.Ajax.get('/groups/searchGroups/0/1/' + term);
				_request.then(function searchResults(response)
				{
					display(response);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for private groups."}]);
				});
			},
			function select(item) {
				$('#clientemaillinkreservation-group_id').val('');

				if (item.id !== null) {
					$('.client-email-group-autocomplete').removeClass('ajax-spinner');
					$('#clientemaillinkreservation-group_id').val(item.id);
				}
			}
		);
	};
}(jQuery, window.Adzuki || {}));